import React, { useCallback, useMemo, useState } from 'react';

import { KEYS } from './feature-flags';
import { type FeatureFlagKey, type FeatureFlagsRecord } from './feature-flags';

export type FeatureFlagsContextType = {
  toggleFlag: (flag: FeatureFlagKey, isChecked: boolean) => void;
  featureFlags: FeatureFlagsRecord;
};

export const FeatureFlagsContext =
  React.createContext<FeatureFlagsContextType | null>(null);
FeatureFlagsContext.displayName = 'FeatureFlags';

/** @deprecated please use useFeatureFlag */
export const useFeatureFlags = (): FeatureFlagsContextType => {
  const ctx = React.useContext(FeatureFlagsContext);
  if (ctx === null) {
    return {
      featureFlags: {} as any,
      toggleFlag: () => {
        /** noop: this is only used during the migration of UP to UP.IA */
      },
    };
  } else {
    return ctx;
  }
};

const getFlagsObj = (flags: FeatureFlagKey[]) =>
  flags.reduce((acc, flag) => {
    acc[flag] = window.localStorage.getItem(flag) === 'true';
    return acc;
  }, {} as FeatureFlagsRecord);

/** @deprecated this provider will be removed */
export const FeatureFlags = ({ children }: React.PropsWithChildren) => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlagsRecord>(
    getFlagsObj(KEYS),
  );

  const toggleFlag = useCallback(
    (flag: FeatureFlagKey, isChecked: boolean) => {
      const temp = { ...featureFlags };
      temp[flag] = isChecked;
      if (isChecked) {
        window.localStorage.setItem(flag, 'true');
      } else {
        window.localStorage.removeItem(flag);
      }
      setFeatureFlags(temp);
    },
    [featureFlags],
  );

  const ffValue = useMemo(
    () => ({
      featureFlags,
      toggleFlag,
    }),
    [featureFlags, toggleFlag],
  );

  return (
    <FeatureFlagsContext.Provider value={ffValue}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
